import React from 'react';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { Header } from './components/layout/Header';
import { BottomNav } from './components/layout/BottomNav';
import { Home } from './pages/Home';
import { BookDetail } from './pages/BookDetail';
import { Reader } from './pages/Reader';
import { Profile } from './pages/Profile';
import { GenrePage } from './pages/GenrePage';
import { Search } from './pages/Search';
import { Library } from './pages/Library';
import { MagicVerify } from './pages/MagicVerify';
import { Stats } from './pages/Stats';
import { Bookmarks } from './pages/Bookmarks';
import { AddBook } from './pages/AddBook';
import { Contact } from './pages/Contact';
import { About } from './pages/About';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { Manifesto } from './pages/Manifesto';

// Layout wrapper to conditionally show Nav/Header based on route
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isReader = location.pathname.includes('/read/');

  return (
    <div className="flex flex-col min-h-screen">
      {!isReader && <Header />}
      <main className="flex-1 w-full max-w-4xl mx-auto">
        {children}
      </main>
      {!isReader && <BottomNav />}
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <HashRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/book/:id" element={<BookDetail />} />
              <Route path="/book/:bookId/read/:chapterId" element={<Reader />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/stats" element={<Stats />} />
              <Route path="/bookmarks" element={<Bookmarks />} />
              <Route path="/genre/:slug" element={<GenrePage />} />
              <Route path="/search" element={<Search />} />
              <Route path="/library" element={<Library />} />
              <Route path="/auth/verify" element={<MagicVerify />} />
              <Route path="/add-book" element={<AddBook />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/manifesto" element={<Manifesto />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="*" element={<div className="p-10 text-center">404 - Page not found</div>} />
            </Routes>
          </Layout>
        </HashRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
